import { memo } from "react"
import { AudioSettings, VideoSettings, AdvancedSettings } from "@vc/views/controlBar/components/settings"

interface SettingsDialogBodyProps {
  tab: "audio" | "video" | "advanced"
}

export const SettingsDialogBody = memo(function SettingsDialogBody({
  tab,
}: SettingsDialogBodyProps) {
  if (tab === "audio") {
    return <AudioSettings />
  }

  if (tab === "video") {
    return <VideoSettings />
  }

  return <AdvancedSettings />
})
